export const SLICE_NAME = 'vaReporterPlans';
